import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Button,
  MenuItem,
  Select,
  TextField,
  Modal,
  IconButton,
  Divider,
} from "@mui/material";
import { useSetRecoilState } from "recoil";
import { showloader } from "../store/gloabalState";
import CloseIcon from "@mui/icons-material/Close";
import { OrgDocList } from "../config/globalVar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import useNotify from "../utils/useNotify";
import { addOrgDocsMeta, getPresignedURLOrg } from "../services/httpCalls";
import { checkFileExtension } from "../utils/check-file-extension";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "auto",
  borderRadius: "10px",
  bgcolor: "background.paper",

  boxShadow: 24,
  p: 2,
};

export function OrgFileUpload({ orgId }) {
  const [open, setOpen] = useState(false);
  const [doctype, setDocType] = useState("");
  const [files, setFiles] = useState();
  const [fileName, setFileName] = useState("");
  const setShowLoader = useSetRecoilState(showloader);
  const inputfileRef = useRef();
  let notify = useNotify();
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });
  };
  const UploadFileandMeta = async (file) => {
    setShowLoader(true);
    await getPresignedURLOrg(orgId, file[0]?.name)
      .then(async (res) => {
        const url = res?.preSignedUrl;

        await uploadFileToS3(res?.preSignedUrl, file[0]).then(async (res) => {
          const newPresSigned = url.split("?")[0];

          const decodedurl = decodeURI(newPresSigned);
          let OrgData = {
            organisationFileMetaList: [
              {
                documentType: doctype,
                url: decodedurl,
              },
            ],
          };
          await addOrgDocsMeta(orgId, OrgData)
            .then((res) => {
              notify.success("File and type Upload successful!");
              resetFile();
            })
            .catch((err) => {
              console.log(err);
              notify.error("Not able to Upload!");
              resetFile();
            });
        });
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        notify.error("Not able to Upload the file!");
        setShowLoader(false);
      });
  };
  const resetFile = () => {
    inputfileRef.current.value = null;
    setFiles(null);
    setFileName(null);
    setDocType("");
  };
  const sendFileMeta = async () => {
    if (files?.length > 0) {
      UploadFileandMeta(files)
        .then(() => {
          handleClose();
          resetFile();
        })
        .catch((err) => {
          console.log(err);
          resetFile();
        });
    } else {
      notify.error("No File Selected!");
    }
  };
  return (
    <Box>
      <Button
        onClick={handleOpen}
        startIcon={<UploadFileIcon />}
        variant="contained"
      >
        File upload
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 1,
                ml: 0.5,
              }}
            >
              UPLOAD FILE
            </Typography>
            <Box>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <Divider
            sx={{
              borderBottom: "1px solid",
            }}
          />
          <Box sx={{}}>
            <FormControl
              sx={{
                mt: "20px",
              }}
              fullWidth
            >
              <InputLabel>Documents</InputLabel>
              <Select
                label="Documents"
                value={doctype}
                onChange={(e) => {
                  setDocType(e.target.value);
                }}
              >
                {OrgDocList.map((item, index) => {
                  return (
                    <MenuItem value={item.value} key={index}>
                      {item.text}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Box marginTop={3}>
              <FormControl fullWidth>
                <TextField
                  type="file"
                  label="Upload File"
                  inputRef={inputfileRef}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    if (e.target.files?.length > 0) {
                      if(!checkFileExtension(e.target.files[0]?.name)){
                        notify.error("Please upload correct file type!");
                        resetFile();
                      } else {
                        setFiles(e.target.files);
                        setFileName(e.target.files[0]?.name);
                      }
                    } else {
                      notify.error("No File Selected!");
                      resetFile();
                    }
                  }}
                />
              </FormControl>
            </Box>
            <Box marginTop={2} sx={{}}>
              <Button
                variant="contained"
                onClick={sendFileMeta}
                disabled={doctype ? false : true}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
